import * as Immutable from "immutable";
import DataLakeWidgetConfig from "data-lake/logic/DataLakeWidgetConfig";
import DataLakeWidget from "data-lake/logic/DataLakeWidget";
import { PAGE_SIZE, WIDGET_DEFAULTS, EXTERNAL_DATA_LAKE_SEARCH_TYPE } from "data-lake/preview/Constants";
import { DEFAULT_FIELDS } from "data-lake/preview/storage-types/external/Constants";
const isDataLakeSearchType = (searchType) => searchType.type === EXTERNAL_DATA_LAKE_SEARCH_TYPE;
const createFromSearchType = (searchType) => {
  const { filters_operator, field_filters, search_after, fields } = searchType;
  return DataLakeWidgetConfig.fromJSON({
    fields,
    size: WIDGET_DEFAULTS.size,
    sort: WIDGET_DEFAULTS.sort,
    tie_breaker: WIDGET_DEFAULTS.tieBreaker,
    filters_operator,
    field_filters,
    after: search_after
  });
};
const createInitialWidget = (previousSearch) => {
  var _a;
  const newWidgetConfig = new DataLakeWidgetConfig(
    void 0,
    Immutable.OrderedSet(DEFAULT_FIELDS),
    PAGE_SIZE,
    WIDGET_DEFAULTS.sort,
    WIDGET_DEFAULTS.tieBreaker,
    WIDGET_DEFAULTS.fieldsOperator,
    Immutable.List()
  );
  const defaultWidget = DataLakeWidget.builder().id(WIDGET_DEFAULTS.id).config(newWidgetConfig).build();
  if (!previousSearch) {
    return defaultWidget;
  }
  const query = previousSearch.queries.first();
  const searchType = query.searchTypes[0];
  if (!searchType || !isDataLakeSearchType(searchType)) {
    return defaultWidget;
  }
  return defaultWidget.toBuilder().config(createFromSearchType(searchType)).streams(searchType.table_id ? [searchType.table_id] : defaultWidget.streams).timerange((_a = query.timerange) != null ? _a : defaultWidget.timerange).build();
};
export default createInitialWidget;
